import type { DetailsPanelContentAttachmentsQuery } from '../queries/__types__/DetailsPanelContentAttachmentsQuery';

export const normalizeContentAttachmentsData = (data?: DetailsPanelContentAttachmentsQuery) => ({
	attachmentsCount: data?.content?.nodes?.[0]?.attachments?.count ?? 0,
});
